
define('text!modules/ads/ads_template.html',[],function () { return '<div class="js-ads-header"></div>\r\n<div class="js-preview-iframe"></div>\r\n<div class="js-ads-list"></div>\r\n';});

